// API base URL is provided per-environment via .env files (Create React App):
//   .env.development -> test backend (yarn start)
//   .env.production  -> prod backend (yarn build)
// Override locally with .env.local. See .env.example.
global.api =
  process.env.REACT_APP_API_URL ||
  "https://aimhengjan-backend-kyd76htk3q-as.a.run.app/";

// App version shown on Login/Navbar — set REACT_APP_VERSION in .env
// (ค่าที่ hardcode ไว้เป็น fallback เผื่อเครื่องที่ยังไม่ได้ copy .env จาก .env.example)
global.version = process.env.REACT_APP_VERSION || "V.1.8.17";

global.message = {
  "Invalid Credentials or activate account":
    "ข้อมูลประจำตัวไม่ถูกต้องหรือเปิดใช้งานบัญชี",
  "There is an active user on this account":
    "บัญชีผู้ใช้งานนี้ได้เข้าสู่ระบบในอุปกรณ์เครื่องอื่นอยู่",
  "Email is not verify": "อีเมลไม่ได้รับการยืนยัน",
  "Email no access permission": "อีเมลนี้ไม่ได้รับอนุญาตให้เข้าถึง",
  "Role no access permission": "ไม่ได้รับอนุญาตให้เข้าถึง",
  "Token is expired": "โทเค็นหมดอายุ",
  "Token is not found": "ไม่พบโทเค็น",
  "User is not found": "ไม่พบผู้ใช้",
  "This Page is not available": "หน้านี้ไม่พร้อมใช้งาน",
  "Role is not found": "ไม่พบบทบาท",
  "Company is not found": "ไม่พบบริษัท",
  "Brand is not found": "ไม่พบยี่ห้อ",
  "BTU is not found": "ไม่พบ BTU",
  "Unit is not found": "ไม่พบหน่วย",
  "Model is not found": "ไม่พบรุ่น",
  "Map air is not found": "ไม่พบรายการแอร์",
  "Spare part is not found": "ไม่พบอะไหล่",
  "Product main is not found": "ไม่พบสินค้า",
  Success: "สำเร็จ",
  "Stock location is not found": "ไม่พบเส้นทางสต๊อก",
  "Stock location is fail stock main not empty":
    "เส้นทางสต็อกล้มเหลว สต็อกหลักไม่ว่างเปล่า",
  "Stock main is not found": "ไม่พบสต๊อก",
  "Stock move is not found": "ไม่พบการย้ายสต๊อก",
  "Stock adjust is not found": "ไม่พบการปรับสต๊อก",
  "Item in stock not enough to remove": "สินค้าในสต็อกไม่เพียงพอที่จะนำออก",
  "Item in stock not enough": "สินค้าในสต็อกไม่เพียงพอ",
  "Stock balance over stock transaction": "ยอดคงเหลือมากกว่าในสต๊อก",
  "Stock balance less 0": "ยอดคงเหลือในสต๊อกน้อยกว่า 0",
  "Commission is not found": "ไม่พบค่าคอมมิชชั่น",
  "Commission employee is not found": "ไม่พบช่าง",
  "Not paid in full": "กรุณาชำระเงินเต็มจำนวน",
  "Status order main is not available": "สถานะคำสั่งซื้อไม่พร้อมใช้งาน",
  "Order main is not found": "ไม่พบคำสั่งซื้อ",
  "Order list is not found": "ไม่พบรายการสั่งซื้อ",
  "Payment detail is not found": "ไม่พบรายละเอียดการชำระเงิน",
  "good receipt main is not found": "ไม่พบใบเสร็จ",
  "the technician has a task on the date":
    "ช่างไม่พร้อมให้บริการในวันและเวลาที่เลือก",
  "Stock qty not zero": "จำนวนสินค้าคงคลังไม่เป็นศูนย์",
  "role name is duplicate": "มีชื่อบทบาทนี้อยู่ในระบบแล้ว",
  "role is not select": "ไม่ได้เลือกบทบาท",
  "role is active": "บทบาททำงานอยู่",
  "email is duplicate": "มีอีเมลนี้อยู่ในระบบแล้ว",
  "full name is duplicate": "มีชื่อนี้อยู่ในระบบแล้ว",
  "company name is duplicate": "มีชื่อบริษัทนี้อยู่ในระบบแล้ว",
  "brand name is duplicate": "มีชื่อยี่ห้อนี้อยู่ในระบบแล้ว",
  "brand is active": "ยี่ห้อทำงานอยู่",
  "btu name is duplicate": "มีชื่อ btu นี้อยู่ในระบบแล้ว",
  "btu is active": "btu ทำงานอยู่",
  "unit name is duplicate": "มีชื่อหน่วยนี้อยู่ในระบบแล้ว",
  "Unit is active": "หน่วยเปิดใช้งาน",
  "model name is duplicate": "มีชื่อรุ่นนี้อยู่ในระบบแล้ว",
  "air map name is duplicate": "มีชื่อรายการแอร์นี้อยู่ในระบบแล้ว",
  "air map is active": "รายการแอร์ทำงานอยู่",
  "spaer part name is duplicate": "มีชื่ออะไหล่นี้อยู่ในระบบแล้ว",
  "Spare part is active": "อะไหล่ทำงานอยู่",
  "product main is duplicate": "มีชื่อสินค้านี้อยู่ในระบบแล้ว",
  "stock location name is duplicate": "มีเส้นทางสต๊อกนี้อยู่ในระบบแล้ว",
  "commission type name is duplicate": "มีชื่อคอมมิชชั่นนี้อยู่ในระบบแล้ว",
  "commission employee is duplicate": "มีชื่อช่างนี้อยู่ในระบบแล้ว",
  "good receipt main is duplicate": "มีใบเสร็จนี้อยู่ในระบบแล้ว",
  "order main number is duplicate": "มีคำสั่งซื้อนี้อยู่ในระบบแล้ว",
  "stock location is active": "เส้นทางสต๊อกใช้งานอยู่",
  "order main number is not found": "ไม่พบหมายเลขคำสั่งซื้อหลัก",
  "user type is not use payment type": "ไม่ได้รับอนุญาตให้เข้าถึง",
  "lot is not found": "ไม่พบล็อต",
  "unit id is none": "กรุณาเลือกหน่วย",
  "This field may not be blank.": "กรุณากรอกชื่อสินค้า",
  "product map id is none": "กรุณาเลือกยี่ห้อ/รุ่น/BTU",
  "spare part type id is none": "กรุณาเลือกประเภทอะไหล่",
  "bank number is duplicate": "พบหมายเลขบัญชีนี้ในระบบ",
  "Type product name is duplicate": "พบชื่อประเภทผ้านี้ในระบบ",
  "warehouse from id is none": "กรุณาเลือกโกดังต้นทาง",
  "warehouse to id is none": "กรุณาเลือกโกดังปลายทาง",
  "qty is none": "กรุณากรอกจำนวนไม้ที่ต้องการย้าย",
  "yard qty is none": "กรุณากรอกจำนวนหลาที่ต้องการย้าย",
  "Can't move product to the same stock location":
    "ไม่สามารถย้ายสินค้าไปยังโกดังเดียวกันได้",
  "user type is not owner ": "ปรับสต๊อกได้เฉาะเจ้าของร้านเท่านั้น",
  "Invoice overdue is not found": "ไม่พบข้อมูล",
  "Payment type is not available": "เลือกวิธีการชำระ",
  "User member id is required": "ต้องระบุรหัสสมาชิกผู้ใช้",
  "Bank is not found": "เลือกธนาคาร",
  "full name transfer is none": "เลือกธนาคาร",
  "qty is not 0 can't delete ":
    "ไม่สามารถลบสินค้าชนิดนี้ได้ เนื่องจากมีสินค้าคงเหลืออยู่ในสต๊อก",
  "warehouse is active": "โกดังมีการใช้งานอยู่",
  "warehouse name is duplicate": "มีชื่อโกดังนี้อยู่ในระบบแล้ว",
  "qty is 0 but yard not 0 ":
    "ไม่สามารถทำการขายสินค้าชนิดนี้ได้ เนื่องจากจำนวนไม้หรือหลา ไม่สอดคล้องกัน",
  "The user still has unpaid bills in the system.":
    "ผู้ใช้ยังมีบิลค้างชำระอยู่ในระบบ",
  "Product category is Using": "ไม่สามารถลบได้ ประเภทผ้ามีการใช้งานอยู่",
  "end date less start date":
    "ไม่สามารถเลือกวันที่สิ้นสุดน้อยกว่าวันที่เริ่มต้น",
  "Credit user is full": "ยอดสั่งซื้อเกินวงเงินที่กำหนด",
  "Invalid moment time": "ช่วงเวลาไม่ถูกต้อง",
  "start date > end date": "ช่วงเวลาไม่ถูกต้อง",
  "warehouse is active default can not delete": "ไม่สามารถลบโกดังหลักได้",
  "this warehouse is still active and warehouse default can't be 0 ":
    "ไม่สามารถบันทึกได้ ระบบต้องมีโกดังหลักอย่างน้อย 1 โกดัง",
  "expense category is duplicate": "พบชื่อหมวดหมู่นี้ในระบบ",
  "All Stock is not found": "ไม่พบสต๊อกทั้งหมด",
  "product list is require": "ไม่มีสินค้าในรายการ",
};

global.role = [
  {
    menu_name: "dashboard",
    name_th: "แดชบอร์ด",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  { menu_name: "header", name_th: "ข้อมูลผู้ใช้", title: true },
  {
    menu_name: "user_admin",
    name_th: "รายชื่อผู้ใช้ทั้งหมด",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "role",
    name_th: "บทบาทผู้ใช้",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  { menu_name: "header", name_th: "รายชื่อบริษัทจำหน่าย", title: true },
  {
    menu_name: "company_supplier",
    name_th: "รายชื่อบริษัทจำหน่าย",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  { menu_name: "header", name_th: "ข้อมูลสมาชิก", title: true },
  {
    menu_name: "user_member",
    name_th: "รายชื่อสมาชิกทั้งหมด",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "user_member_rate",
    name_th: "เรทสมาชิก",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  { menu_name: "header", name_th: "รายการขาย", title: true },
  {
    menu_name: "all_sale",
    name_th: "การขายทั้งหมด",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "all_sale_member",
    name_th: "ข้อมูลตามสมาชิก",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "invoice",
    name_th: "ใบแจ้งหนี้",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "payment_receive",
    name_th: "ระบบรับชำระเงิน",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  { menu_name: "header", name_th: "จัดการสินค้า", title: true },
  {
    menu_name: "all_product",
    name_th: "สินค้าทั้งหมด",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "update_price",
    name_th: "ปรับราคาตามประเภทผ้า",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "goods_receipt",
    name_th: "ใบรับสินค้า",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "type_product",
    name_th: "จัดการประเภทผ้า",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  { menu_name: "header", name_th: "จัดการสต๊อก", title: true },
  {
    menu_name: "move_stock",
    name_th: "รายการย้ายสต๊อก",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "adjust_stock",
    name_th: "รายการปรับสต๊อก",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "transaction_stock",
    name_th: "เส้นทางสต๊อก",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  { menu_name: "header", name_th: "จัดการคอมมิสชัน", title: true },
  {
    menu_name: "status_delivery",
    name_th: "สถานะส่ง",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "type_commission",
    name_th: "ประเภทคอมมิสชัน",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  { menu_name: "header", name_th: "สรุปรายงาน", title: true },
  {
    menu_name: "report_summary",
    name_th: "สรุปรายงาน",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "report_sales_customers",
    name_th: "รายงานสรุปยอดขายจากลูกค้ารายบุคคล",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "report_sales_products",
    name_th: "รายงานสรุปยอดขายสินค้าและบริการทั้งหมด",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "report_inventory",
    name_th: "รายงานสรุปมูลค่าสินค้าคงคลัง",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "report_products_and_services",
    name_th: "รายงานสรุปยอดขายสินค้าและบริการ",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "report_transfer",
    name_th: "รายการโอน",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "report_expenses",
    name_th: "รายการค่าใช้จ่าย",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "report_refund",
    name_th: "รายการคืนสินค้า",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "report_reciept",
    name_th: "รายการรับเข้า",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  {
    menu_name: "warehouse",
    name_th: "โกดังสินค้า",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "bank_account",
    name_th: "บัญชีธนาคาร",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  { menu_name: "header", name_th: "จัดการค่าใช้จ่าย", title: true },
  {
    menu_name: "expenses",
    name_th: "บันทึกค่าใช้จ่าย",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "type_expenses",
    name_th: "จัดการหมวดหมู่ค่าใช้จ่าย",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },

  {
    menu_name: "refund",
    name_th: "คืนสินค้า",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "logaudit",
    name_th: "ประวัติการตรวจสอบ",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "refund_accumulate",
    name_th: "เงินคืนสะสม",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "generate_barcode",
    name_th: "สร้างบาร์โค้ด",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "check_stock",
    name_th: "เช็คสต็อก",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
  {
    menu_name: "pos_system",
    name_th: "ระบบ POS",
    permission: {
      view: false,
      create: false,
      update: false,
      delete: false,
      download: false,
      upload: false,
    },
  },
];
